/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { renderToString } from 'react-dom/server';

import YouTube from 'react-youtube';
import ReactPlayer from 'react-player';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';

import {
  APIHandler,
  SocialIcons,
  Sharing,
  SharingPopup,
  DataHandler,
  StorageHandler,
  AddFavorite,
  ShareButton,
} from 'C4';
import { storageKeys, baseAppId } from 'settings';

// Import css files
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Slider from 'react-slick';

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-right']} />
    </div>
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-left']} />
    </div>
  );
}

function setSocial(socialUrl, socialType) {
  let soc = '';

  if (socialUrl === null || socialUrl === '') {
    return '';
  }

  if (String(socialUrl).includes('http') || String(socialUrl).includes('www.')) {
    return socialUrl;
  }

  switch (socialType) {
    case 'facebook':
      soc = `https://www.facebook.com/${socialUrl}`;
      break;
    case 'twitter':
      soc = `https://twitter.com/${socialUrl}`;
      break;
    case 'youtube':
      soc = `https://www.youtube.com/${socialUrl}`;
      break;
    case 'tripadvisor':
      soc = `https://www.tripadvisor.com/${socialUrl}`;
      break;
    case 'yelp':
      soc = `https://www.yelp.nl/biz/${socialUrl}`;
      break;
    case 'instagram':
      soc = `https://www.instagram.com/${socialUrl}`;
      break;
    case 'pinterest':
      soc = `https://www.pinterest.com/${socialUrl}`;
      break;
    default:
    // code block
  }

  return soc;
}

function setSocialState(company) {
  return {
    facebook: setSocial(company.company_facebook, 'facebook'),
    twitter: setSocial(company.company_twitter, 'twitter'),
    youtube: setSocial(company.company_youtube, 'youtube'),
    tripadvisor: setSocial(company.company_tripadvisor, 'tripadvisor'),
    yelp: setSocial(company.company_yelp, 'yelp'),
    instagram: setSocial(company.company_instagram, 'instagram'),
    pinterest: setSocial(company.company_pinterest, 'pinterest'),
    other: setSocial(company.company_other),
    tiktok: setSocial(company.company_tiktok, 'tiktok'),
  };
}

function fillFancybox(url) {
  return {
    infobar: true,
    buttons: ['close'],
    share: {
      tpl: renderToString(<SharingPopup url={url} />),
    },
    caption: '',
  };
}

const shareAnalytics = (name, profileId, value) => {
  console.log(name);
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj.response);
      APIHandler.trackEvent(appId, profileId, email, 'profile', name, value).then(() => {});
    });
  });
};

export class CompanyProfile extends Component {
  constructor(props) {
    super(props);

    // this.shareAnalytics = this.shareAnalytics.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      reps: [],
      playVideo: true,
      viewed: [],
      qualityIndex: 0,
      currentVideo: '',
      quality: [
        { name: '720', hash: 'kTA1qc4f' },
        { name: '406', hash: 'DA7zOnMs' },
        { name: '270', hash: '2oBCa4mK' },
        { name: '180', hash: 'YnNQqrRg' },
      ],
      company: {
        photo_url: '',
        video: '',
        company_name: [],
        company_description: '',
        company_web_home: '',
        company_facebook: '',
        company_twitter: '',
        company_youtube: '',
        company_tripadvisor: '',
        company_yelp: '',
        company_instagram: '',
        company_pinterest: '',
        company_other: '',
        uploaded_videos: [],
        stream_videos: [],
        header_image: [
          {
            image_url: '',
          },
        ],
        brochures: [],
        post: [],
      },
      requestCompleted: false,
    };
  }

  // onClick={() => trackShare('carousel', parsedTitle)}

  componentDidMount() {
    const { profileId } = this.props;
    window.addEventListener('scroll', this.handleScroll);

    APIHandler.getProfile(profileId).then((res) => {
      if (res.result === 'success') {
        this.setState({
          company: res.response,
          requestCompleted: true,
          reps: res.response.chat,
        });
      } else {
        this.setState({
          requestCompleted: false,
        });
      }
      return null;
    });

    const viewed = localStorage.getItem('viewedExhibitions')
      ? localStorage.getItem('viewedExhibitions').split(',')
      : [];
    this.setState({ viewed });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    this.setViewed(this.state.company.id);
  }

  handleScroll() {
    if (window.scrollY > 35) {
      this.setState({ playVideo: false });
    }
  }

  setViewed(id) {
    const current = localStorage.getItem('viewedExhibitions')
      ? localStorage.getItem('viewedExhibitions').split(',')
      : [];

    if (!current.includes(id)) localStorage.setItem('viewedExhibitions', [...current, id]);

    const { video } = this.state.company;
    if (video) {
      shareAnalytics('play-uploaded-video', this.state.company.id, video);
    }
  }

  onPlay(videoUrl) {
    // Only once, if multi time stopped
    const { currentVideo } = this.state;
    if (currentVideo !== videoUrl) {
      shareAnalytics('play-uploaded-video', this.state.company.id, videoUrl);
      this.setState({ currentVideo: videoUrl });
    }
  }

  render() {
    const {
      viewed,
      qualityIndex,
      quality,
      company,
      reps,
      company: {
        photo_url,
        video,
        company_name,
        company_description,
        company_web_home,
        company_city,
        company_street_address,
        company_zip,
        company_state,
        company_facebook,
        company_twitter,
        company_phone,
        company_youtube,
        company_email,
        company_tripadvisor,
        company_yelp,
        company_instagram,
        company_pinterest,
        company_other,
        uploaded_videos,
        stream_videos,
        header_image,
        brochures,
        post,
        company_web_res,
        lat,
        lon,
        jw,
      },
      playVideo,
      requestCompleted,
    } = this.state;

    const opts = {
      height: '390',
      width: '640',
    };

    let vid = '';
    if (jw) {
      vid = jw;
      vid = vid.replace('https://content.jwplatform.com/players/', '');
      vid = vid.replace('-gj8NKibk.html', '');
    }

    let videoDownload = '';
    if (video) {
      videoDownload = video;
      videoDownload = videoDownload.replace(
        'https://front.travpromobile.com/',
        'https://front.travpromobile.com/',
      );
    }

    const { profileId } = this.props;

    const sliderSettings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      adaptiveHeight: true,
      autoplay: false,
      autoplaySpeed: 3000,
      draggable: true,
      cssEase: 'linear',
      nextArrow: <NextArrow className="slider-next" />,
      prevArrow: <PrevArrow />,
    };

    if (requestCompleted) {
      return (
        <div className="boothContainer">
          {/* (!String(Object.values(setSocialState(company))).includes('undefined')) */}
          <div className="boothHeader">
            {header_image.length < 1 && !jw ? (
              <img src={photo_url} alt="logo" id="boothLogo" style={{ gridColumn: 'span 5' }} />
            ) : (
              <img src={photo_url} alt="logo" id="boothLogo" />
            )}

            {!jw ? (
              header_image.length > 0 && (
                <img id="boothImage" src={header_image[0].image_url} alt="placeholder thumbnail" />
              )
            ) : (
              <div id="boothVideo">
                <ReactPlayer
                  width="100%"
                  height="100%"
                  url={`https://cdn.jwplayer.com/manifests/${vid}.m3u8`}
                  //                  light={`https://cdn.jwplayer.com/thumbs/${vid}-720.jpg`}
                  controls
                  playing={playVideo && !viewed.includes(String(company.id))}
                />
              </div>
            )}
          </div>
          <span className="companyName">{company_name}</span>

          <FontAwesomeIcon className="bounce" icon="chevron-down" />

          <style>
            {
              '\
            #openWidget { display: none; bottom: 3rem; } #logoHeader { display: none; } '
            }
          </style>

          <div className="boothContent">
            {post !== undefined && post.length > 0 && (
              <div className="companyPosts">
                {post.map(msg => (
                  <div>
                    {!msg.webLink && <p dangerouslySetInnerHTML={{ __html: msg.message }} />}
                    {msg.webLink && (
                      <a
                        key={msg.id}
                        href={msg.webLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        dangerouslySetInnerHTML={{ __html: msg.message }}
                      />
                    )}
                  </div>
                ))}
              </div>
            )}

            <div className="companyInfo">
              <h4>Overview:</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: company_description.split('<p>&nbsp;</p>').join(''),
                }}
              />
            </div>
            <hr />

            {header_image !== undefined && header_image.length > 0 && (
              <div className="companyImages">
                <h4>Shareable Images:</h4>
                <Slider {...sliderSettings}>
                  {header_image.map(image => (
                    <div className="holderBooth">
                      <AddFavorite
                        appId={baseAppId}
                        viewType={company_name}
                        upID={image.image_url}
                        pageID={company_name}
                        onClick={() => shareAnalytics('favorite-image', profileId, image.image_url)}
                      />
                      <ShareButton
                        url={image.image_url}
                        title={image.title}
                        customClass="trainingContent__shareBtn"
                        profileId={profileId}
                      />

                      <SharingPopup
                        url={image.image_url}
                        triggerId={image.id}
                        profileId={profileId}
                      />
                      <a
                        onClick={() => shareAnalytics('open-image', profileId, image.image_url)}
                        data-fancybox={image.image_url}
                        href={image.image_url}
                        data-options={JSON.stringify(fillFancybox(image.image_url))}
                      >
                        <img
                          key={image.id}
                          className="slidingImage"
                          alt="company"
                          src={image.image_url.replace('&w=800', '&w=300')}
                        />
                        {image.title && <div className="titleImg">{image.title}</div>}
                      </a>
                    </div>
                  ))}
                </Slider>
                <hr />
              </div>
            )}

            {((stream_videos !== undefined && stream_videos.length > 0) ||
              (uploaded_videos !== undefined && uploaded_videos.length > 0)) && (
              // && (company.stream_videos.includes(typeof String) || company.uploaded_videos.includes(typeof String))
                <div className="companyVideos">
                  <h4>Shareable Videos:</h4>
                  <div className="companyVideos_Grid">
                    {uploaded_videos
                    .map(vid =>
                        vid && (
                          <div className="video">

                            <AddFavorite
                              appId={baseAppId}
                              viewType={company_name}
                              upID={`${vid.title}:::${vid.url}`}
                              pageID={company_name}
                              onClick={() =>
                                shareAnalytics('favorite-uploaded-video', profileId, vid.url)
                              }
                            />


                            <video
                              key={vid.id}
                              src={vid.url}
                              poster=""
                              height="100%"
                              width="100%"
                              controls
                              onPlay={() => this.onPlay(vid.url)}
                            >
                              <track kind="captions" />
                            </video>


                            <div className="title">{vid.title}</div>
                            <ShareButton
                              dataFancyboxTrigger={vid.id}
                              title={vid.title}
                              data-fancybox
                              dataSource={`#${vid.id}`}
                              url={vid.url}
                              customClass="trainingContent__shareBtn"
                              profileId={profileId}
                            />
                            <SharingPopup url={vid.url} triggerId={vid.id} profileId={profileId} />
                          </div>
                        ))}

                    {stream_videos &&
                    stream_videos[0] !== '' &&
                    stream_videos.length > 0 &&
                    uploaded_videos &&
                    uploaded_videos[0] !== '' &&
                    uploaded_videos.length > 0 && <hr />}

                    {stream_videos
                    // .filter((vid) => typeof vid === 'string')
                    .map(vid =>
                        vid &&
                        // <div className="holderBooth">
                        vid.length !== 11 && (
                          <div className="streamedVideo">
                            <AddFavorite
                              appId={baseAppId}
                              viewType={company_name}
                              upID={`https://player.vimeo.com/video/${vid}?loop=false&amp;byline=false&amp;portrait=false&amp;title=true&amp;speed=true&amp;transparent=0&amp;gesture=media`}
                              onClick={() =>
                                shareAnalytics(
                                  'favorite-streamed-video',
                                  profileId,
                                  `https://player.vimeo.com/video/${vid}?loop=false&amp;byline=false&amp;portrait=false&amp;title=true&amp;speed=true&amp;transparent=0&amp;gesture=media`,
                              )
                              }
                            />
                            <div className="video">
                              <ReactPlayer
                                width="100%"
                                height="100%"
                                url={`https://player.vimeo.com/video/${vid}?loop=false&amp;byline=false&amp;portrait=false&amp;title=true&amp;speed=true&amp;transparent=0&amp;gesture=media`}
                                onStart={() => this.onPlay(`https://player.vimeo.com/video/${vid}`)}
                                controls
                                config={{ vimeo: { playerOptions: { title: true, share: false } } }}
                              />
                            </div>
                          </div>
                          // </div>
                        ))}

                    {stream_videos
                    // .filter((vid) => typeof vid === 'string')
                    .map(vid =>
                        vid && (
                          <React.Fragment>
                            {vid.length === 11 && (
                              <div className="streamedVideo">
                                <AddFavorite
                                  appId={baseAppId}
                                  viewType={company_name}
                                  upID={`https://www.youtube.com/embed/${vid}`}
                                  onClick={() =>
                                    shareAnalytics(
                                      'play-streamed-video',
                                      profileId,
                                      `https://www.youtube.com/embed/${vid}`,
                                  )
                                  }
                                />
                                <YouTube
                                  videoId={vid}
                                  id={vid}
                                  className="video"
                                  opts={opts}
                                  onPlay={() => this.onPlay(`https://www.youtube.com/embed/${vid}`)}
                                />
                              </div>
                            )}
                          </React.Fragment>
                        ))}
                  </div>

                  <hr />
                </div>
            )}

            {brochures !== undefined && brochures.length > 0 && (
              <div className="companyBrochures">
                <h4>Shareable Brochures:</h4>
                <div className="companyBrochures_Grid">
                  {brochures.map(brochure => (
                    <div className="boothBrochure">
                      <AddFavorite
                        appId={baseAppId}
                        viewType={company_name}
                        upID={`${brochure.title}:::https://stack.travpromobile.com/viewer.php?file=${brochure.url}#zoom=75`}
                        onClick={() => shareAnalytics('favorite-brochure', profileId, brochure.url)}
                      />
                      <ShareButton
                        dataFancyboxTrigger={brochure.id}
                        title={brochure.title}
                        data-fancybox
                        dataSource={`#${brochure.id}`}
                        customClass="trainingContent__shareBtn"
                        url={brochure.url}
                        profileId={profileId}
                      />
                      <SharingPopup
                        url={`https://stack.travpromobile.com/viewer.php?file=${brochure.url}#zoom=75`}
                        triggerId={brochure.id}
                        profileId={profileId}
                      />
                      <a
                        onClick={() => shareAnalytics('open-brochure', profileId, brochure.url)}
                        data-fancybox={brochure.id}
                        href={`https://stack.travpromobile.com/viewer.php?file=${brochure.url}#zoom=75`}
                        data-options={JSON.stringify(fillFancybox(`https://stack.travpromobile.com/viewer.php?file=${brochure.url}#zoom=75`))}
                      >
                        <img src={`${brochure.thumbnail.replace('tradecdn.travpromobile.com', 'tradecdn.imgix.net')}?width=200`} alt="placeholder thumbnail" />
                        <div className="title">{brochure.title}</div>
                      </a>
                    </div>
                  ))}
                </div>
                <hr />
              </div>
            )}

            <div className="companySharing">
              <h4>Share this booth with others:</h4>
              <div role="button" tabIndex={0}>
                <Sharing withText hideDownload url={window.location.href} profileId={profileId} />
              </div>
            </div>

            <hr />

            {company_other !== undefined && (
              <div className="companySocials">
                <div className="companyWebsites">
                  <h4>Visit us:</h4>
                  {company_web_home && company_web_home !== '' && (
                    <a
                      onClick={() => {
                        shareAnalytics('visit-website', profileId, company_web_home);
                      }}
                      id="companyWebsite"
                      href={company_web_home}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon="globe-americas" />
                      {'Website '}&gt;{'\r'}
                    </a>
                  )}
                  {company_web_res && company_web_res !== '' && (
                    <a
                      onClick={() => {
                        shareAnalytics('visit-website', profileId, company_web_res);
                      }}
                      id="companyWebsite"
                      href={company_web_res}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon="globe-americas" />
                      {'Reservation Center '}&gt;{'\r'}
                    </a>
                  )}
                </div>
                <div className="socialMedia">
                  <h4>Follow us on:</h4>
                  <SocialIcons propSocials={setSocialState(company)} />
                </div>
              </div>
            )}

            <hr />

            <div className="companyLocation">
              <div>
                <Map
                  className="map"
                  google={this.props.google}
                  zoom={13}
                  initialCenter={{ lat, lng: lon }}
                >
                  <Marker name={company_name} />
                </Map>
              </div>
              <div className="location">
                <h3>Address</h3>
                {company_street_address}
                <br />
                {company_city}
                <br />
                {company_state}
                <br />
                {company_zip}
                <br />
                <h3>Contact</h3>
                <a href={`phone:${company_phone}`}>
                  <FontAwesomeIcon icon={['fas', 'phone']} /> {company_phone}
                </a>
                <br />
                <a href={company_web_home} target="_blank">
                  <FontAwesomeIcon icon={['fas', 'link']} /> {company_web_home}
                </a>
                <br />
                <a href={`mailto:${company_email}`}>
                  <FontAwesomeIcon icon={['fas', 'envelope']} /> {company_email}
                </a>
                <br />
              </div>
            </div>

            <hr />
            <div id="favePage">
              <AddFavorite
                appId={baseAppId}
                viewType={company_name}
                upID={`${photo_url}:::${window.location.href}`}
              />
            </div>
          </div>
\
        </div>
      );
    }
    return <div className="boothContainer" />;
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyBpfyrBMTrgHH3YnaGHxfjEN_w7OXBJoqc',
})(CompanyProfile);

CompanyProfile.propTypes = {
  profileId: PropTypes.number.isRequired,
};
